export const PRAXIS_PLAY_EVENTS = {
  AUTH_SIGNIN_INITIATED: "AUTH_SIGNIN_INITIATED",
  AUTH_SIGNIN_SUCCESS: "AUTH_SIGNIN_SUCCESS",
  AUTH_MFA_REQUESTED: "AUTH_MFA_REQUESTED",
  AUTH_PASSWORD_RECOVERY_INITIATED: "AUTH_PASSWORD_RECOVERY_INITIATED",
  AUTH_TENANT_SELECTION_INITIATED: "AUTH_TENANT_SELECTION_INITIATED",
  AUTH_COHORT_SELECTED: "AUTH_COHORT_SELECTED",
  PRAXISPLAY_SESSION_INITIATED: "PRAXISPLAY_SESSION_INITIATED",
  PRAXISPLAY_SESSION_STARTED: "PRAXISPLAY_SESSION_STARTED",
  PRAXISPLAY_SESSION_TERMINATED: "PRAXISPLAY_SESSION_TERMINATED",
  PRAXISPLAY_SESSION_COMPLETED: "PRAXISPLAY_SESSION_COMPLETED",
  DASHBOARD_ACCESSED: "DASHBOARD_ACCESSED",
  DASHBOARD_QUICK_ACTION_TAPPED: "DASHBOARD_QUICK_ACTION_TAPPED",
  FEEDBACK_VIEWED: "FEEDBACK_VIEWED",
  FEEDBACK_PERFORMANCE_TAB_ACCESSED: "FEEDBACK_PERFORMANCE_TAB_ACCESSED",
  FEEDBACK_SESSION_RECAP_TAB_ACCESSED: "FEEDBACK_SESSION_RECAP_TAB_ACCESSED",
  DETAILED_REPORT_ACCESSED: "DETAILED_REPORT_ACCESSED",
  DETAILED_REPORT_METRIC_SELECTED: "DETAILED_REPORT_METRIC_SELECTED",
  HCP_CUSTOMIZATION_INITIATED: "HCP_CUSTOMIZATION_INITIATED",
  HCP_SETTINGS_SAVED: "HCP_SETTINGS_SAVED",
  SURVEY_EXPERIENCE_LEVEL_SELECTED: "SURVEY_EXPERIENCE_LEVEL_SELECTED",
  SURVEY_COMPLETED: "SURVEY_COMPLETED",
  POSTCALL_SURVEY_SHOWN: "survey shown",
  POSTCALL_SURVEY_SENT: "survey sent",
  POSTCALL_SURVEY_DISMISSED: "survey dismissed",
  MOBILE_WEB_ACCESS_BLOCKED: "MOBILE_WEB_ACCESS_BLOCKED",
};
